import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const ClientsPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.clients.pageHeader.title')} />
}

ClientsPageHeader.displayName = 'ClientsPageHeader'
export default ClientsPageHeader
